import ApiClient from "@/api/ApiClient";
import {
  MultimediaCartListResponse,
  MultimediaCartItemListResponse,
  MultimediaCartItemResponse,
  MessageOkResponse,
  RedirectUrlResponse,
} from "@API/src/component/memoruHome/cart/types";
import {
  FetchCartListRequest,
  PutCartListRequestItem,
  PostCartItemRequest,
  DeleteCartItemRequest,
  FetchMultimediaPriceRequest,
  CheckoutCartRequest,
  SecureTranRequest,
} from "@/model/request/cart";
import {
  isTypeMultimediaCartListResponse,
  isTypeMultimediaCartItemListResponse,
  isTypeMultimediaCartItemResponse,
  isTypeMessageOkResponse,
  isTypeMemoruUnitPriceResponse,
  isTypeRedirectUrlResponse,
} from "@/model/typeGuard/cart";

export default class ApiCart {
  public static async fetchCartList(
    request: FetchCartListRequest
  ): Promise<MultimediaCartItemListResponse> {
    const response = await ApiClient.get(`/cart/items`, request);
    if (isTypeMultimediaCartItemListResponse(response)) {
      return response;
    }
    throw response;
  }

  public static async putCartList(
    request: MultimediaCartItemListResponse
  ): Promise<MultimediaCartItemListResponse> {
    const response = await ApiClient.put(`/cart/items`, request);
    if (isTypeMultimediaCartItemListResponse(response)) {
      return response;
    }
    throw response;
  }

  public static async postCartItem(
    request: PostCartItemRequest
  ): Promise<MultimediaCartItemResponse> {
    const response = await ApiClient.post(
      `/cart/items/${request.multimediaId}`,
      request
    );
    if (isTypeMultimediaCartItemResponse(response)) {
      return response;
    }
    throw response;
  }

  public static async deleteCartItem(
    request: DeleteCartItemRequest
  ): Promise<MessageOkResponse> {
    const response = await ApiClient.delete(
      `/cart/items/${request.multimediaId}`,
      request
    );
    if (isTypeMessageOkResponse(response)) {
      return response;
    }
    throw response;
  }

  public static async fetchMultimediaPrice(
    request: FetchMultimediaPriceRequest
  ) {
    const response = await ApiClient.get(
      `/multimedia/${request.multimediaId}/price`,
      request
    );
    if (isTypeMemoruUnitPriceResponse(response)) {
      return response;
    }
    throw response;
  }

  public static async checkoutCart(
    request: CheckoutCartRequest
  ): Promise<RedirectUrlResponse> {
    const response = await ApiClient.post(`/cart/checkout`, request);
    if (isTypeRedirectUrlResponse(response)) {
      return response;
    }
    throw response;
  }

  public static async checkoutCartSecureTran(
    request: SecureTranRequest
  ): Promise<MessageOkResponse> {
    console.log("checkoutCartSecureTran in ApiCart.ts");
    const response = await ApiClient.post(`/cart/secure-tran`, request);
    if (isTypeMessageOkResponse(response)) {
      sessionStorage.removeItem('accessPass');
      return response;
    }
    sessionStorage.removeItem('accessPass');
    throw response;
  }

  public static async checkoutError(): Promise<MessageOkResponse> {
    console.log("checkoutError in ApiCart.ts");
    const response = await ApiClient.post(`/cart/checkout/error`, {});
    if (isTypeMessageOkResponse(response)) {
      return response;
    }
    throw response;
  }
}
